export class PetTotalTransactionModel {
    pet_no: number 
    totaltransaction: number
     
    constructor(
        pet_no: number ,
        totaltransaction: number
    ) { 
        this.pet_no = pet_no
        this.totaltransaction = totaltransaction 
    }
}